import { AlignmentType, Document, Header as DocXHeader, IRunOptions, Paragraph } from "docx";
import { Body, breakLine, C, Header, line, table, text } from "./common";
import { getDDMMYYYFormat } from "../../../../../../helper/dateTimeHelper";
import { DateFormat } from "../../../../../../constants";
import { DateHelper } from "../../../../../../helper";
import { IEmployee } from "../../../../../../models";

const getPlaneTicketForm = (item: any, isReroute: boolean, getEmployeesByEmail: (email: string) => IEmployee | null) => {
  const jsonString = item.eContent;
  const dataArray = JSON.parse(jsonString);
  const day = new Date(item.createdDateTime).getDate();
  const month = new Date(item.createdDateTime).getMonth() + 1;
  const year = new Date(item.createdDateTime).getFullYear();
  const createUser = getEmployeesByEmail(item.createdByEmail)?.Title || item.createdByEmail;
  
  const getUnit = () => {
    const department = item.eDepartment;
    const unit = item.eUnit;
    let result = unit;
    if (department === "Chi nhánh Tân Sơn Nhất")
      result += ' TSN';
    else if (department === "Chi nhánh Nội Bài")
      result += ' NB';
    else if (department === "Chi nhánh Đà Nẵng")
      result += ' ĐN';
    return result.toUpperCase();
  }

  const renderTripBusiness = (trip: any[]): Paragraph => {
    const texts: IRunOptions[] | any[] = [];
    trip.forEach((e: any, index: number) => texts.push({text: `${e.from} - ${e.to} (${DateHelper.formatDateToString(e.date, {format: DateFormat.DD_MM_YYYY_HH_MM})})`, break: index > 0 ? 1 : 0}))
    return text(texts);
  }
  // Create the document
  return new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, [
                  text(
                    [
                      { text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM", size: 22 },
                      {
                        text: getUnit(),
                        break: 1,
                        size: 24,
                      },
                    ],
                    {
                      alignment: AlignmentType.CENTER,
                    }
                  ),
                  line(1000)
                ]),
                C.col(undefined, Header.rightParagraph)
              ),
            ],
          }),
        },
        children: [
          Body.Date,

          breakLine(2),

          text(
            { text: `GIẤY ĐỀ NGHỊ ${!isReroute ? 'CẤP' : 'HOÀN'} VÉ CÔNG TÁC`, bold: true },
            { alignment: AlignmentType.CENTER }
          ),

          breakLine(2),

          text({ text: `Căn cứ: Theo quyết định ${item.eBaseOnDecision?.trim() || ''}.`, italics: true }),

          breakLine(1),

          text(`Kính đề nghị Văn phòng Công ty ${!isReroute ? 'cấp' : 'hoàn'} vé và giấy công tác chi tiết như sau:`),

          breakLine(1),

          text("Họ và tên người đi công tác:"),

          breakLine(1),

          text(
            (dataArray as { Name: string }[]).map<IRunOptions>((item, index) => ({
              text: `${index + 1}. ${item.Name}`,
              ...(index !== 0 && { break: 1 }),
            })),
            {
              alignment: AlignmentType.LEFT,
            }
          ),

          breakLine(1),

          text(`Nơi đến công tác: ${item.eOffice}`),

          breakLine(1),

          text(`Thời gian công tác: ${getDDMMYYYFormat(item.eWorkingTime)} - ${getDDMMYYYFormat(item.eFinishTime)}`),

          breakLine(1),

          text(`Hành trình: ${item.eTrip}`),

          breakLine(1),

          text(`Nội dung: ${item.eDescription}`),

          breakLine(2),

          //footer
          C.row(
            C.col(50, [
              text(
                [
                  {
                    text: "THỦ TRƯỞNG ĐƠN VỊ",
                    bold: true,
                  },
                  {
                    text: item.eApprovedBy ? item.eApprovedBy.split('|')[1] : '',
                    bold: true,
                    break: 5,
                  },
                ],
                {
                  alignment: AlignmentType.CENTER,
                }
              ),
            ]),
            C.col(50, [
              text(
                [
                  {
                    text: item.eApprovedByITHead.split('|')[0] === "hieptd@viags.vn" ?  "CHÁNH VĂN PHÒNG CÔNG TY" : "NGƯỜI DUYỆT",
                    bold: true,
                  },
                  {
                    text: item.eApprovedByITHead ? item.eApprovedByITHead.split('|')[1] : '',
                    bold: true,
                    break: 5,
                  },
                ],
                {
                  alignment: AlignmentType.CENTER,
                }
              ),
            ])
          ),
          
          breakLine(4),
        ],
      },
      {
        headers: {
          default: new DocXHeader({
            children: [text([{ text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM", bold: true }])],
          }),
        },
        children: [
          text([{ text: `ĐƠN VỊ: ${item.eUnit}`, bold: true }]),

          breakLine(2),

          text([{ text: "THÔNG TIN YÊU CẦU ĐẶT CHỖ", bold: true }], {
            alignment: AlignmentType.CENTER,
          }),

          breakLine(1),

          table<{ Name: string; Position: string; TripBusiness: any[] }>({
            columns: [
              {
                label: "Stt",
                renderText: (value, index) => text((index + 1).toString()),
              },
              {
                label: "Họ và tên",
                renderText: (value) => text(value.Name),
              },
              {
                label: "Chức danh",
                renderText: (value) => text(value.Position),
              },
              {
                label: "Hành trình",
                renderText: (value) => renderTripBusiness(value.TripBusiness)
              },
            ],
            data: dataArray,
          }),

          breakLine(2),

          C.row(
            C.col(40),
            C.col(60, [
              text(
                [
                  { text: `Tp. Hồ Chí Minh, ngày ${day} tháng ${month} năm ${year}.`, italics: true },
                  { text: "Người lập", break: 1 },
                  { text: createUser, break: 4 },

                ],
                { alignment: AlignmentType.CENTER }
              ),
            ])
          ),
        ],
      },
    ],
  });
};

export default getPlaneTicketForm;
